enum TraceType {
    PRODUCT_ORDER_CREATED_TRACE = "PRODUCT_ORDER_CREATED_TRACE",
    PRODUCT_ORDER_OBSERVATION_TRACE = "PRODUCT_ORDER_OBSERVATION_TRACE",
    MISCELLANY_ORDER_DESCRIPTION_TRACE = "MISCELLANY_ORDER_DESCRIPTION_TRACE",
}

export default TraceType;